module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_Japan.44bbee9b.jpg";